<template>
  <v-chip-group
    v-model="slider"
    mandatory
    center-active
    active-class="secondary font-weight-medium"
  >
    <h-chip
      v-for="category in categories"
      :key="category.id"
      v-bind="category"
    />
  </v-chip-group>
</template>

<script>
  import Configurable from '@/Mixins/Configurable'
  import HChip from './ChipsItem'

  export default {
    mixins: [
      Configurable,
    ],

    components: {
      HChip,
    },

    computed: {
      slider: {
        get () {
          return this.$store.state.orders.menu.category
        },
        set (v) {
          this.$store.commit('orders/menu/category', v)
          if(this.config('fastMenuEntry')) {
            this.$store.commit('orders/menu/dishOrder', v)
          }
        },
      },
      categories () {
        return this.$store.state.orders.menu.categories
      },
    },
  }
</script>
